/*
 * Collection infinite scroll.
 * Replaces the numbered pagination (1 2 3 ... Next) with automatic loading:
 * when the shopper gets close to the bottom of the grid, the next page of
 * products is fetched and appended until there are no more products.
 *
 * - If anything goes wrong the normal pagination is shown again.
 * - New product cards are handed to the theme (empire.js) through the
 *   "infinite-scroll:append" event so swatches, Quick Shop, compare etc. work.
 */
(function () {
  'use strict';

  if (window.__fteInfiniteScroll) return;
  window.__fteInfiniteScroll = true;

  var ROOT_CLASS = 'fte-infinite';
  var GRID_SELECTOR = '[data-productgrid-items]';
  var NEXT_SELECTOR = '.pagination--next a';

  function injectStyles() {
    if (document.getElementById('fte-infinite-styles')) return;
    var style = document.createElement('style');
    style.id = 'fte-infinite-styles';
    style.textContent =
      '.' + ROOT_CLASS + ' .pagination--container{display:none!important}' +
      '.fte-infinite-sentinel{display:flex;justify-content:center;align-items:center;width:100%;min-height:1px;padding:0}' +
      '.fte-infinite-sentinel.is-loading{min-height:64px;padding:16px 0}' +
      '.fte-infinite-spinner{display:none;width:28px;height:28px;border:3px solid rgba(0,0,0,.15);border-top-color:rgba(0,0,0,.6);border-radius:50%;animation:fte-infinite-spin .8s linear infinite}' +
      '.fte-infinite-sentinel.is-loading .fte-infinite-spinner{display:block}' +
      '@keyframes fte-infinite-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.fte-infinite-spinner{animation-duration:2s}}';
    document.head.appendChild(style);
  }

  function absoluteUrl(href) {
    try {
      return new URL(href, window.location.href).href;
    } catch (e) {
      return null;
    }
  }

  function itemKey(el) {
    return el.getAttribute('data-product-quickshop-url') || '';
  }

  function start() {
    var grid = document.querySelector(GRID_SELECTOR);
    var nextLink = document.querySelector(NEXT_SELECTOR);

    // Single page of products (or not a collection grid): nothing to do.
    if (!grid || !nextLink) return;

    var nextUrl = absoluteUrl(nextLink.getAttribute('href'));
    if (!nextUrl) return;

    var loading = false;
    var finished = false;
    var root = document.documentElement;

    var seen = {};
    Array.prototype.forEach.call(grid.children, function (el) {
      var key = itemKey(el);
      if (key) seen[key] = true;
    });

    injectStyles();
    root.classList.add(ROOT_CLASS);

    var sentinel = document.createElement('div');
    sentinel.className = 'fte-infinite-sentinel';
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.innerHTML = '<span class="fte-infinite-spinner" aria-hidden="true"></span>';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    var observer = null;

    function finish() {
      finished = true;
      if (observer) observer.disconnect();
      sentinel.classList.remove('is-loading');
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    }

    function fallbackToPagination() {
      // Show the regular numbered pagination again.
      root.classList.remove(ROOT_CLASS);
      finish();
    }

    function recheck() {
      // Re-arm the observer: if the sentinel is still near the viewport
      // (short pages / tall screens) this triggers the next load right away.
      if (finished || !observer) return;
      observer.unobserve(sentinel);
      observer.observe(sentinel);
    }

    function loadNext() {
      if (loading || finished || !nextUrl) return;
      loading = true;
      sentinel.classList.add('is-loading');

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(GRID_SELECTOR);
          if (!newGrid) throw new Error('Product grid not found');

          var appended = [];
          var fragment = document.createDocumentFragment();

          Array.prototype.forEach.call(newGrid.children, function (el) {
            if (!el.classList || !el.classList.contains('productgrid--item')) return;
            var key = itemKey(el);
            if (key && seen[key]) return; // avoid duplicates if the order shifted
            if (key) seen[key] = true;
            var node = document.importNode(el, true);
            fragment.appendChild(node);
            appended.push(node);
          });

          grid.appendChild(fragment);

          // Lazy images (responsive-image helper in the theme).
          appended.forEach(function (node) {
            node.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
          });

          // Let the theme initialise swatches, Quick Shop, compare, etc.
          document.dispatchEvent(
            new CustomEvent('infinite-scroll:append', { detail: { items: appended } })
          );

          var link = doc.querySelector(NEXT_SELECTOR);
          nextUrl = link ? absoluteUrl(link.getAttribute('href')) : null;

          loading = false;
          sentinel.classList.remove('is-loading');

          if (!nextUrl) {
            finish();
          } else {
            recheck();
          }
        })
        .catch(function (error) {
          loading = false;
          if (window.console && console.warn) {
            console.warn('[infinite-scroll] falling back to pagination:', error);
          }
          fallbackToPagination();
        });
    }

    if (!('IntersectionObserver' in window)) {
      fallbackToPagination();
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadNext();
            break;
          }
        }
      },
      { root: null, rootMargin: '0px 0px 900px 0px', threshold: 0 }
    );
    observer.observe(sentinel);
  }

  // Wait for the theme scripts so new cards can be initialised properly.
  if (document.readyState === 'complete') {
    setTimeout(start, 0);
  } else {
    window.addEventListener('load', function () {
      setTimeout(start, 0);
    });
  }
})();
